<template>
  <li>
    <div class="form-horizontal">
      <div class="row">
        <div class="checkbox checkbox-primary col-sm-8">
          <input
            type="checkbox"
            name="opportunities[]"
            :value="{ id: grandchildOpportunity.id }"
            :id="`checkbox-opportunity-${opportunity.id}-${grandchildOpportunity.id}`"
            v-model="stateOpportunities">
          <label :for="`checkbox-opportunity-${opportunity.id}-${grandchildOpportunity.id}`">
            {{ grandchildOpportunity.name }}
          </label>
        </div>
        <div class="col-sm-3" v-if="opportunitiesWithBudget.includes(childOpportunity.name.trim().toLowerCase())">
          <div :class="$hasErrorClass($v.stateOpportunityGrandChildrenBudget, 'form-group')">
            <input disabled type="text" placeholder="Budget" v-model="$v.stateOpportunityGrandChildrenBudget.$model" class="form-control"/>
            <vuelidate-help label="Budget" :field="$v.stateOpportunityGrandChildrenBudget"/>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { stateMapper } from 'mixins/users'
import {decimal} from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  mixins: [stateMapper],
  props: {
    grandchildOpportunity: {
      type: Object,
      required: true
    },
    opportunity: {
      type: Object,
      required: true
    },
    budgets: {
      required: false,
      type: Array
    }
  },
  mounted () {
    this.budgets && this.budgets.map(x => {
      if (this.childOpportunity.id === x.opportunity_id) {
        this.$v.stateOpportunityGrandChildrenBudget.$model = x.budget
        // this.setGrandChildBudget(x.opportunity_id)
      }
    })
  },
  data () {
    return {
      stateOpportunityGrandChildrenBudget: null
    }
  },

  validations () {
    return {
      stateOpportunityGrandChildrenBudget: {
        decimal
      }
    }
  },

  // methods: {
  //   setGrandChildBudget (id) {
  //     this.$emit('input', {id, budget: this.$v.stateOpportunityChildrenBudget.$model})
  //   }
  // },
  components: {
    VuelidateHelp
  }
}
</script>

<style scoped>

</style>
